import { teamMeta } from "../../data/plTeams";

export function TeamBadge({ team, size = "md" }: { team: string; size?: "sm" | "md" | "lg" }) {
  const m = teamMeta(team);
  const dims = size === "sm" ? "h-7 w-7 text-[9px]" : size === "lg" ? "h-14 w-14 text-sm" : "h-10 w-10 text-[11px]";
  return (
    <span aria-hidden className={`relative inline-flex shrink-0 items-center justify-center rounded-[40%_40%_50%_50%] border-[2.5px] border-[#0B1F33] font-comic tracking-wide shadow-[0_2px_0_#0B1F33] ${dims}`}
      style={{ background: `linear-gradient(135deg, ${m.bg} 0 58%, ${m.fg} 58% 64%, ${m.bg} 64%)`, color: m.fg }}>
      <span className="rounded bg-black/25 px-0.5 leading-none text-white">{m.code}</span>
    </span>
  );
}
